// 💾 /src/hooks/useMultiStepForm.ts
import { useState } from "react"

export interface UseMultiStepFormOptions {
  steps: number
  validators: Record<number, () => boolean>
}

export const useMultiStepForm = ({ steps, validators }: UseMultiStepFormOptions) => {
  const [step, setStep] = useState(1)
  const [errors, setErrors] = useState<{ [key: string]: string }>({})

  const handleNext = () => {
    const validate = validators[step]
    if (validate && !validate()) return
    setErrors({})
    if (step < steps) setStep(step + 1)
  }

  const handleBack = () => {
    if (step > 1) setStep(step - 1)
  }

  return {
    step,
    setStep,
    errors,
    setErrors,
    handleNext,
    handleBack
  }
}
